import { useGetMetadataCurrency } from "../../api/currency";

export interface Root {
  code: string;
  name: string;
  isActive: boolean;
}

export const useMetadataCurrency = () => {
  const {
    data = {
      data: [],
    },
    isLoading,
  } = useGetMetadataCurrency();

  const filterData = data.data.filter((item: Root) => {
    return item.isActive;
  });

  const metadataCurrency = filterData.map((item: Root) => {
    return {
      value: item.code,
      label: item.code,
    };
  });

  return { metadataCurrency, dataCurrency: filterData, isLoading };
};
